import Skills from './Skills';
export default Skills